import { createContext } from 'react'
import { Lazy, ObjectSchema } from 'yup'

export interface FormContextProps {
  schema?: ObjectSchema<Record<string, unknown>> | Lazy
  submitResponseError?: string
}

export const FormContext = createContext<FormContextProps>({})
export const FormPrefixContext = createContext<string>('')
